import { IPublicClientApplication } from "@azure/msal-browser";
import configData from "../config.json";
import { ConfigData } from "../models/config";
import { getAccessToken } from "../utils/AuthUtils";
const config = configData as ConfigData;

export class BaseService {
  private instance: IPublicClientApplication;
  constructor(instance: IPublicClientApplication) {
    this.instance = instance;
  }

  getEndPoint(): string {
    return configData.API_BASE_URL;
  }

  getHeaderOption(method: string): any {
    var headers = new Headers();
    var bearer = "Bearer " + localStorage.getItem("accessToken");
    headers.append("Authorization", bearer);
    var options = {
      method: method,
      headers: headers,
    };
    return options;
  }

  async getHeaderOptionWithToken(
    url: string,
    method: string
  ): Promise<Response> {
    // Create the header (with token in it)
    var headers = new Headers();
    var bearer = "Bearer " + localStorage.getItem("accessToken");
    headers.append("Authorization", bearer);

    var options = {
      method: method,
      headers: headers,
    };

    // Make API call
    const response = await fetch(url, options);
    console.log(response.status);
    // If the call failed, refetch the token
    if (response.status === 401) {
      console.log(
        "[WARNING] Existing token has expired, a token refresh is required."
      );

      const loginRequest = {
        scopes: [config.API_SCOPE],
      };

      const newToken = await getAccessToken(this.instance, loginRequest);
      console.log(newToken);

      localStorage.setItem("accessToken", newToken);
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${newToken}`);

      const retryOptions = {
        ...options,
        headers,
      };

      return fetch(url, retryOptions);
    }

    return response;
  }
}
